import React from 'react';
import { FeedbackThreadEntry } from '../types';
import { FeedbackThreadEntryCard } from './FeedbackThreadEntryCard';

interface FeedbackThreadEntriesProps {
  entries: FeedbackThreadEntry[];
  stacked?: boolean;
}

export function FeedbackThreadEntries({
  entries,
  stacked
}: FeedbackThreadEntriesProps) {
  return (
    <>
      {entries.map(entry => {
        const isNote = entry.type === 'REQUESTOR_NOTE';
        const entryId =
          entry.type === 'REQUESTOR_NOTE'
            ? entry.requestorNoteId
            : entry.feedbackId;

        return (
          <FeedbackThreadEntryCard
            key={`${entry.type}:${entryId}`}
            entryId={entryId}
            label={isNote ? 'Requestor Note' : 'Feedback'}
            author={entry.author}
            content={entry.content}
            sentAt={entry.sentAt}
            editable={entry.editable}
            bordered={isNote}
            stacked={stacked}
          />
        );
      })}
    </>
  );
}
